import { generateState } from '../builder'

export default {
  audiences: [],
  audience: {},
  ...generateState('getAudiences'),
  ...generateState('getAudience'),
}
